import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, font, motion } = theme.custom;
    return {
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '10px 16px',
            borderBottom: `1px solid ${color.border}`,
            backgroundColor: color.primary.soft,
            color: color.primary.onSoft,
            fontSize: 13,
            fontWeight: 600,
            flexWrap: 'wrap',
        },
        toolbarActions: { display: 'flex', gap: 8, marginLeft: 'auto', flexWrap: 'wrap' },
        container: { maxHeight: 'calc(100vh - 330px)' },
        mono: { fontFamily: font.mono, fontSize: 13, whiteSpace: 'nowrap' },
        nowrap: { whiteSpace: 'nowrap' },
        thumb: {
            display: 'block',
            width: 56,
            height: 56,
            borderRadius: radius.sm,
            objectFit: 'cover',
            backgroundColor: color.surfaceMuted,
            outline: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
            outlineOffset: -1,
        },
        thumbButton: {
            position: 'relative',
            width: 56,
            height: 56,
            padding: 0,
            border: 'none',
            borderRadius: radius.sm,
            overflow: 'hidden',
            cursor: 'pointer',
            backgroundColor: color.surfaceMuted,
            display: 'block',
            '&:hover $thumbOverlay': { backgroundColor: 'rgba(0, 0, 0, 0.15)' },
            '&:focus-visible': { outline: `2px solid ${color.focusRing}`, outlineOffset: 2 },
        },
        thumbOverlay: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            color: '#FFFFFF',
            transitionProperty: 'background-color',
            transitionDuration: motion.fast,
            '& svg': { fontSize: 28, filter: 'drop-shadow(0 1px 3px rgba(0,0,0,.5))' },
        },
        thumbBadge: {
            position: 'absolute',
            right: 3,
            bottom: 3,
            padding: '1px 5px',
            borderRadius: 4,
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
            color: '#FFFFFF',
            fontSize: 10,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            '& svg': { fontSize: 12 },
        },
        preview: { display: 'block', maxWidth: 360, maxHeight: 400, borderRadius: radius.sm },
        actions: { display: 'flex', gap: 6, justifyContent: 'flex-end', whiteSpace: 'nowrap' },
        // image lightbox
        lightbox: {
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(5, 8, 20, 0.92)',
            zIndex: 1500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 16,
            padding: 24,
        },
        lightboxClose: { position: 'absolute', top: 16, right: 16, color: '#FFFFFF' },
        lightboxNav: { color: '#FFFFFF', backgroundColor: 'rgba(255,255,255,0.08)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.16)' } },
        lightboxImage: { maxWidth: 'min(90vw, 1200px)', maxHeight: '80vh', objectFit: 'contain', display: 'block', borderRadius: radius.md },
        lightboxBar: { display: 'flex', justifyContent: 'center', gap: 12, marginTop: 12, alignItems: 'center', color: 'rgba(255,255,255,0.8)', fontSize: 13 },
    };
});
